

export default {
  locale: 'sv',
  Pagination: {
    items_per_page: '/ sida',
    jump_to: 'Gå till',
    jump_to_confirm: 'bekräfta',
    page: 'Sida',
    prev_page: 'Föreg sida',
    next_page: 'Nästa sida',
    prev_5: 'Föreg 5 sidor',
    next_5: 'Nästa 5 sidor',
    prev_3: 'Föreg 3 sidor',
    next_3: 'Nästa 3 sidor',
    page_size: 'sidstorlek'
  },
  DatePicker: {
    lang: {
      placeholder: 'Välj datum',
      rangePlaceholder: ['Startdatum', 'Slutdatum'],
      locale: 'sv_SE',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Till idag',
      ok: 'Ok',
      clear: 'Avbryt',
      month: 'Månad',
      year: 'År',
      timeSelect: 'Välj tidpunkt',
      dateSelect: 'Välj datum',
      monthSelect: 'Välj månad',
      yearSelect: 'Välj år',
      decadeSelect: 'Välj årtionde',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-MM-DD H:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Förra månaden (PageUp)',
      nextMonth: 'Nästa månad (PageDown)',
      previousYear: 'Föreg år (Control + left)',
      nextYear: 'Nästa år (Control + right)',
      previousDecade: 'Föreg årtionde',
      nextDecade: 'Nästa årtionde',
      previousCentury: 'Föreg århundrade',
      nextCentury: 'Nästa århundrade',
      yearPlaceholder: 'Välj år',
      quarterPlaceholder: 'Välj kvartal',
      monthPlaceholder: 'Välj månad',
      weekPlaceholder: 'Välj vecka',
      rangeYearPlaceholder: ['Startår', 'Slutår'],
      rangeMonthPlaceholder: ['Startmånad', 'Slutmånad'],
      rangeWeekPlaceholder: ['Startvecka', 'Slutvecka']
    },
    timePickerLocale: {
      placeholder: 'Välj tid'
    }
  },
  TimePicker: {
    placeholder: 'Välj tid'
  },
  Calendar: {
    lang: {
      placeholder: 'Välj datum',
      rangePlaceholder: ['Startdatum', 'Slutdatum'],
      locale: 'sv_SE',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Till idag',
      ok: 'Ok',
      clear: 'Avbryt',
      month: 'Månad',
      year: 'År',
      timeSelect: 'Välj tidpunkt',
      dateSelect: 'Välj datum',
      monthSelect: 'Välj månad',
      yearSelect: 'Välj år',
      decadeSelect: 'Välj årtionde',
      yearFormat: 'YYYY',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'D',
      dateTimeFormat: 'YYYY-MM-DD H:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Förra månaden (PageUp)',
      nextMonth: 'Nästa månad (PageDown)',
      previousYear: 'Föreg år (Control + left)',
      nextYear: 'Nästa år (Control + right)',
      previousDecade: 'Föreg årtionde',
      nextDecade: 'Nästa årtionde',
      previousCentury: 'Föreg århundrade',
      nextCentury: 'Nästa århundrade',
      yearPlaceholder: 'Välj år',
      quarterPlaceholder: 'Välj kvartal',
      monthPlaceholder: 'Välj månad',
      weekPlaceholder: 'Välj vecka',
      rangeYearPlaceholder: ['Startår', 'Slutår'],
      rangeMonthPlaceholder: ['Startmånad', 'Slutmånad'],
      rangeWeekPlaceholder: ['Startvecka', 'Slutvecka']
    },
    timePickerLocale: {
      placeholder: 'Välj tid'
    }
  },
  Table: {
    filterTitle: 'Filtermeny',
    filterConfirm: 'OK',
    filterReset: 'Återställ',
    filterEmptyText: 'Inga filter',
    emptyText: 'Ingen data',
    selectAll: 'Markera nuvarande sida',
    selectInvert: 'Invertera nuvarande sida',
    selectNone: 'Avmarkera all data',
    selectionAll: 'Markera all data',
    sortTitle: 'Sortera',
    expand: 'Expandera rad',
    collapse: 'Komprimera rad',
    triggerDesc: 'Klicka för att sortera i fallande ordning',
    triggerAsc: 'Klicka för att sortera i stigande ordning',
    cancelSort: 'Klicka för att avbryta sortering'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Avbryt',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Avbryt'
  },
  Transfer: {
    searchPlaceholder: 'Sök här',
    itemUnit: 'objekt',
    itemsUnit: 'objekt',
    titles: ['', ''],
    remove: 'Ta bort',
    selectCurrent: 'Markera nuvarande sida',
    removeCurrent: 'Ta bort nuvarande sida',
    selectAll: 'Markera all data',
    removeAll: 'Ta bort all data',
    selectInvert: 'Invertera nuvarande sida'
  },
  Empty: {
    description: 'Ingen data'
  },
  Text: {
    edit: 'Redigera',
    copy: 'Kopiera',
    copied: 'Kopierad',
    expand: 'Expandera'
  },
  Upload: {
    uploading: 'Laddar upp...',
    removeFile: 'Ta bort fil',
    uploadError: 'Uppladdningsfel',
    previewFile: 'Förhandsgranska fil',
    downloadFile: 'Ladda ned fil'
  },
  global: {
    placeholder: 'Vänligen välj'
  },
  Icon: {
    icon: 'ikon'
  },
  PageHeader: {
    back: 'Tillbaka'
  },
  Image: {
    preview: 'Förhandsgranska'
  }
};
